export const initialPaginationStandart = {
  page: 1,
  per_page: 10,
};

export const initialPaginationDocumentaryType = {
  page: 1,
  per_page: 50,
};

export const initialPaginationStandarTwentyItems = {
  page: 1,
  per_page: 20,
};

export const initialPaginationStandarOneHundredItems = {
  page: 1,
  per_page: 100,
};

export const initialPaginationStandarThreeHundredItems = {
  page: 1,
  per_page: 300,
};

export const initialPaginationStandarThousandItems = {
  page: 1,
  per_page: 1000,
};

export const initialPaginationFieldConfig = {
  page: 1,
  per_page: 1000,
  search: "",
};
